import axios from "axios";
import { API_BASE_URL, getRequest } from "../../api";

const token = () => sessionStorage.getItem("token") || "";
const headers = () => ({
  Authorization: `Bearer ${token()}`,
  uid: sessionStorage.getItem("uid"),
  "X-Tenant-Id": sessionStorage.getItem("selectedCompanyId"),
});

export const fetchScormModuleProgress = (moduleId) =>
  getRequest({
    url: `${API_BASE_URL}/api/responsable/modules/${moduleId}/scorm/progress`,
    token: token(),
  }).then((response) => response.data);

export const fetchScormUserProgress = (moduleId, userId) =>
  getRequest({
    url: `${API_BASE_URL}/api/responsable/modules/${moduleId}/scorm/progress/users/${userId}`,
    token: token(),
  }).then((response) => response.data);

export const fetchScormUserInteractions = (moduleId, userId) =>
  getRequest({
    url: `${API_BASE_URL}/api/responsable/modules/${moduleId}/scorm/progress/users/${userId}/interactions`,
    token: token(),
  }).then((response) => response.data);

export const fetchScormUserObjectives = (moduleId, userId) =>
  getRequest({
    url: `${API_BASE_URL}/api/responsable/modules/${moduleId}/scorm/progress/users/${userId}/objectives`,
    token: token(),
  }).then((response) => response.data);

export const fetchScormContentProgress = (moduleId, contentId) =>
  getRequest({
    url: `${API_BASE_URL}/api/responsable/modules/${moduleId}/scorm/progress/contents/${contentId}`,
    token: token(),
  }).then((response) => response.data);

export const exportScormModuleProgress = (moduleId) =>
  axios.get(`${API_BASE_URL}/api/responsable/modules/${moduleId}/scorm/progress/export`, {
    headers: headers(),
    responseType: "blob",
  });

export const exportScormInteractions = (moduleId) =>
  axios.get(`${API_BASE_URL}/api/responsable/modules/${moduleId}/scorm/progress/interactions/export`, {
    headers: headers(),
    responseType: "blob",
  });
